import React from 'react';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';
import { Card, CardHeader, CardActions, CardText } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { createCategory, updateCategory, deleteCategory } from '../actions/category';
import {withRouter} from 'react-router'
import Checkbox from 'material-ui/Checkbox';

class CategoryForm extends React.Component {
  constructor(props) {
    super();
    this.state = {
      ...props.category
    }
    if (!props.category) {
      this.state.type = props.type || "option";
    }
    this.checkTitleText = this.checkTitleText.bind(this);
  }

  render() {
    let header = this.props.category ? "Update Category" : "New Category";
    return (
      <Card style={{maxWidth: 400, margin: "0px auto", marginBottom: 20}}>
        <CardHeader
          title={header}
        />
        <CardText>
          <TextField
            style={{width: "100%"}}
            ref="title"
            hintText="Category Title"
            defaultValue={this.state.title}
            errorText={this.state.titleErrorMessage}
            onChange={this.checkTitleText}
          /><br />
          <TextField
            style={{display: this.state.type === "question" ? "none" : "block", width: "100%"}}
            hintText="Category Description"
            ref="description"
            multiLine={true}
            defaultValue={this.state.description}
          /><br />
          {
            this.state.type === 'option' && <Checkbox
              ref="inputCategory"
              label="Assessment Category (Previously 'Input Category' - Assessment Only)"
              defaultChecked={this.props.category ? this.props.category.inputCategory : false}
            />
          }
          <br />
        </CardText>
        <CardText>
        <CardActions expandable={true} style={{textAlign: "right"}}>
          <FlatButton onClick={this.cancel.bind(this)} label="cancel" />
          <RaisedButton onClick={this.submit.bind(this)} primary={true} label="Save" />
        </CardActions>
        </CardText>
      </Card>
    )
  }

  checkTitleText() {
    if (this.refs.title.getValue() < 1) {
      this.setState({titleErrorMessage: "Required Field"});
      return false
    } else {
      this.setState({titleErrorMessage: null});
      return true
    }

  }

  submit() {
    if (this.checkTitleText()) {
      let attrs = {
        title: this.refs.title.getValue(),
        description: this.refs.description.getValue(),
        type: this.state.type,
        inputCategory: this.refs.inputCategory ? this.refs.inputCategory.isChecked() : false
      };
      if (this.props.category) {
        this.props.onUpdate(this.props.category.id, attrs)
      } else {
        this.props.onCreate(attrs);
      }
      this.props.router.goBack();
    }
  }

  delete() {
    this.props.onDelete(this.props.category.id);
    this.goBack();
  }

  cancel() {
    this.goBack();
  }

  goBack() {
    this.props.router.goBack();
  }

}

const mapStateToProps = (state, ownProps) => {
  let id = parseInt(ownProps.routeParams.id);
  return {
    category: state.categories.find((c) => c.id === id),
    type: ownProps.routeParams.type
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onCreate: (props) => dispatch(createCategory(props)),
    onUpdate: (id, props) => dispatch(updateCategory(id, props)),
    onDelete: (id) => dispatch(deleteCategory(id))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CategoryForm));
